import { render, staticRenderFns } from "./EditModuleModal.vue?vue&type=template&id=0c87dbde&"
import script from "./EditModuleModal.vue?vue&type=script&lang=js&"
export * from "./EditModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports